import React from "react";
import { Col, Row } from "react-bootstrap";
import { useSelector } from "react-redux";

export default function CardCount(props) {
  const { page } = props;
  const Count = useSelector((state) => state.statehome.knowledgeCount);
  console.log("page ", page);
  return (
    <div className="all-card">
      {page === "knowledge" ? (
        <Row>
          <Col>
            <div className="card">
              <div className="card-body ">
                <h5 className="card-title text-title">องค์ความรู้เดิม</h5>
                <h2 className="card-text text-amount">
                  {Count.countknowledge ? Count.countknowledge : 0}
                </h2>
              </div>
            </div>
          </Col>
          <Col>
            <div className="card">
              <div className="card-body ">
                <h5 className="card-title text-title">นวัตกรรม</h5>
                <h2 className="card-text text-amount">
                  {Count.countinnovation ? Count.countinnovation : 0}
                </h2>
              </div>
            </div>
          </Col>
          <Col>
            <div className="card">
              <div className="card-body ">
                <h5 className="card-title text-title">องค์ความรู้ใหม่</h5>
                <h2 className="card-text text-amount">
                  {Count.countnewknowledge ? Count.countnewknowledge : 0}
                </h2>
              </div>
            </div>
          </Col>
        </Row>
      ) : page === "goal" ? (
        <Row>
          <Col>
            <div className="card">
              <div className="card-body ">
                <h5 className="card-title text-title">BCG</h5>
                <h2 className="card-text text-amount">
                  {Count.countBcg ? Count.countBcg : 0}
                </h2>
              </div>
            </div>
          </Col>
          <Col>
            <div className="card">
              <div className="card-body ">
                <h5 className="card-title text-title">SDGs</h5>
                <h2 className="card-text text-amount">
                  {Count.countSdg ? Count.countSdg : 0}
                </h2>
              </div>
            </div>
          </Col>
          <Col>
            <div className="card">
              <div className="card-body ">
                <h5 className="card-title text-title">10S-Curve</h5>
                <h2 className="card-text text-amount">
                  {Count.countCurve ? Count.countCurve : 0}
                </h2>
              </div>
            </div>
          </Col>
          <Col>
            <div className="card">
              <div className="card-body ">
                <h5 className="card-title text-title">RMUTI Cluster</h5>
                <h2 className="card-text text-amount">
                  {Count.countCluster ? Count.countCluster : 0}
                </h2>
              </div>
            </div>
          </Col>
        </Row>
      ) : page === "impact" ? (
        <Row>
          <Col>
            <div className="card">
              <div className="card-body ">
                <h5 className="card-title text-title">เศรษฐกิจ</h5>
                <h2 className="card-text text-amount">
                  {Count.countEconomy ? Count.countEconomy : 0}
                </h2>
              </div>
            </div>
          </Col>
          <Col>
            <div className="card">
              <div className="card-body ">
                <h5 className="card-title text-title">สังคม</h5>
                <h2 className="card-text text-amount">
                  {Count.countSocial ? Count.countSocial : 0}
                </h2>
              </div>
            </div>
          </Col>
          <Col>
            <div className="card">
              <div className="card-body ">
                <h5 className="card-title text-title">วัฒนธรรม</h5>
                <h2 className="card-text text-amount">
                  {Count.countCultural ? Count.countCultural : 0}
                </h2>
              </div>
            </div>
          </Col>
          <Col>
            <div className="card">
              <div className="card-body ">
                <h5 className="card-title text-title">สิ่งแวดล้อม</h5>
                <h2 className="card-text text-amount">
                  {Count.countEnvironment ? Count.countEnvironment : 0}
                </h2>
              </div>
            </div>
          </Col>
        </Row>
      ) : page === "newknowledge" ? (
        <Row>
          <Col>
            <div className="card">
              <div className="card-body ">
                <h5 className="card-title text-title">นวัตกรรม</h5>
                <h2 className="card-text text-amount">
                  {Count.countinnovation ? Count.countinnovation : 0}
                </h2>
              </div>
            </div>
          </Col>
          <Col>
            <div className="card">
              <div className="card-body ">
                <h5 className="card-title text-title">องค์ความรู้ใหม่</h5>
                <h2 className="card-text text-amount">
                  {Count.countnewknowledge ? Count.countnewknowledge : 0}
                </h2>
              </div>
            </div>
          </Col>
        </Row>
      ) : null}
    </div>
  );
}
